import { createTheme } from "@mui/material/styles";

declare module '@mui/material/styles' {
  interface Palette {
    user: Palette['primary'];
    family: Palette['primary'];
    userList: {
      selected: string;
      hover: string;
    };
    uploadFile: {
      dragOver: string;
    };
    brand: {
      blue: string;
      darkBlue: string;
      darkPurple: string;
      green: string;
      darkGreen: string;
      purple: string;
      purpleLight: string;
      brown: string;
      yellow: string;
      orange: string;
      lightBlue: string;
    };
  }
  interface PaletteOptions {
    user?: PaletteOptions['primary'];
    family?: PaletteOptions['primary'];
    userList?: {
      selected?: string;
      hover?: string;
    };
    uploadFile?: {
      dragOver?: string;
    };
    brand?: {
      blue?: string;
      darkBlue?: string;
      darkPurple?: string;
      green?: string;
      darkGreen?: string;
      purple?: string;
      purpleLight?: string;
      brown?: string;
      yellow?: string;
      orange?: string;
      lightBlue?: string;
    };
  }
}

const theme = createTheme({
  palette: {
    primary: {
      main: 'rgb(177, 208, 138)',
    },
    secondary: {
      main: 'rgb(33, 181, 136)',
    },
    background: {
      default: "#f4f4f4", // רקע כללי
    },
    user: {
      main: '#1976d2',
    },
    family: {
      main: '#4caf50',
    },
    userList: {
      selected: '#e0f7fa',
      hover: '#f1f1f1',
    },
    uploadFile: {
      dragOver: '#e0f7fa',
    },
    brand: {
      blue: "#5278eb",
      darkBlue: "#232089",
      darkPurple: "#5D77DF",
      green: "#e0e855",
      darkGreen: "#E1E86F",
      purple: "#b7b9f5",
      purpleLight: "#EEEFF9",
      brown: "#6d1727",
      yellow: "#F5F2C9",
      orange: "#FB7045",
      lightBlue: "#D9E7E9",
    },
  },
  typography: {
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    h1: {
      fontSize: "2rem",
      fontWeight: 700,
    },
    h6: {
      fontSize: "1.2rem",
      fontWeight: 500,
    },
  },
  direction: "rtl", // ✅ תמיכה מלאה ב-RTL
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          "& .MuiButton-startIcon": {
            paddingLeft: "5px !important", // ✅ מחייב מרווח בצד שמאל
         
          },
        },
      },
    },
  
  },
});

export default theme;
